"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fluidScaleRemBase = exports.fluidScalePxBase = exports.fluidScaleCalc = exports.fluidScaleBase = void 0;
exports.pxToRem = pxToRem;
exports.stripUnit = void 0;
// Base functions
// Common application-wide mixins, such as for writing media
// queries or fluidly scaling type and space values.
// --------------------------------------------------------
// Media queries
// --------------------------------------------------------
const DEFAULT_BREAKPOINTS = {
  130: "1280px",
  50: "516px"
}; // Fluid Elements
// --------------------------------------------------------
// Set min and max sizes and breakpoints and let  fluidly scale different properties in-between
// This function is meant to be used as a base for your mixin, with your defined breakpoints

const fluidScalePxBase = (max, min, maxVw, minVw) => {
  const maxNum = stripUnit(max);
  const minNum = stripUnit(min);

  if (minNum > maxNum) {
    return `clamp(${max}, ${fluidScaleCalc(max, min, maxVw, minVw)}, ${min})`;
  }

  return `clamp(${min}, ${fluidScaleCalc(max, min, maxVw, minVw)}, ${max})`;
}; // `fluidScaleBase` is the legacy name for `fluidScalePxBase`


exports.fluidScalePxBase = fluidScalePxBase;
const fluidScaleBase = fluidScalePxBase; // return fluid-scale calc value

exports.fluidScaleBase = fluidScaleBase;

const fluidScaleCalc = function (maxValue, minValue) {
  let maxVw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_BREAKPOINTS[130];
  let minVw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_BREAKPOINTS[50];
  return `calc(${minValue} + ${stripUnit(maxValue) - stripUnit(minValue)} * (100vw - ${minVw}) / ${stripUnit(maxVw) - stripUnit(minVw)})`;
}; // adapted from https://css-tricks.com/linearly-scale-font-size-with-css-clamp-based-on-the-viewport/


exports.fluidScaleCalc = fluidScaleCalc;

const fluidScaleRemBase = function (maxPx, minPx, maxVwRem, minVwRem) {
  let pxPerRem = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 16;
  const maxRem = pxToRem(maxPx, pxPerRem);
  const minRem = pxToRem(minPx, pxPerRem);
  const max = parseFloat(maxRem);
  const min = parseFloat(minRem);
  const maxVw = parseFloat(maxVwRem);
  const minVw = parseFloat(minVwRem);
  if (max === min) return maxRem;
  const slope = (max - min) / (maxVw - minVw);
  const yAxisIntersection = -minVw * slope + min;
  const preferredValue = `${yAxisIntersection.toFixed(3)}rem + ${(slope * 100).toFixed(4)}vw`;
  return `clamp(${minRem}, ${preferredValue}, ${maxRem})`;
}; // used by fluid-scale mixin


exports.fluidScaleRemBase = fluidScaleRemBase;

const stripUnit = unit => {
  return parseInt(unit.toString().replace(/[^\d\.]/g, "")); // eslint-disable-line no-useless-escape
}; // convert px to em


exports.stripUnit = stripUnit;

function pxToRem(px) {
  let base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  return stripUnit(px) / base + "rem";
}